import React, { Component } from 'react';
import Switch from '../../Part_Sample/Switch';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class User_Administration extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();
		let accounts = this.props.param.accounts;

		this.state = {
			accounts: accounts,
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	handleAddAccount = () => {
		if (window.app.state.is_msm_mode) {
			this.props.content_handler('MSM_Add_Edit_Account', { username: null, accounts: this.props.param.accounts });
		} else {
			this.props.content_handler('Add_Edit_Account', { username: null, accounts: this.props.param.accounts });
		}
	}

	handleEditAccount = (username) => {
		if (window.app.state.is_msm_mode) {
			this.props.content_handler('MSM_Add_Edit_Account', { username: username, accounts: this.props.param.accounts });
		} else {
			this.props.content_handler('Add_Edit_Account', { username: username, accounts: this.props.param.accounts });
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			width: this.props.width - 40,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			overflow: 'hidden',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('user_administration')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddAccount}
					/>

					<div style={{ overflow: 'auto', height: this.props.height - 140, paddingBottom: 60 }}>
						{Object.keys(this.state.accounts).map((username) => {
							let account = this.state.accounts[username];
							// Do not display Service users
							if (account.class == 'Service') {
								return null;
							} else {
								return (
									<div style={button_style} >
										<div style={{ textAlign: 'left', verticalAlign: 'top', marginLeft: 20, paddingTop: 10, paddingBottom: 10 }} onClick={() => this.handleEditAccount(username)}>
											<span>{username}</span>
										</div>
									</div>
								)
							}
						})}
					</div>
				</div>
			</div>
		)
	}
}